<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> {{ pageTitle }} </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <div>
        <span class="page-title">{{ pageTitle }}</span>
      </div>
    </div>

    <div class="content-container">
      <div class="container">
        <div class="steps-content">
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">公司名称</span>
            </div>
            <div class="field-content">
              {{ company.companyName }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">所属资源合作方</span>
            </div>
            <div class="field-content">
              {{ company.partnerName }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">股转完成状态</span>
            </div>
            <div class="field-content">
              {{ company.equityReady ? '已完成': '未完成' }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">营业执照</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <p v-if="license.docList.length===0">--暂无--</p>
                <p v-for="doc in license.docList" :key="doc.uid">
                  <a @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                  <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
                </p>
              </div>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">行政审批局出具工商登记底档</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <p v-if="bizDoc.docList.length===0">--暂无--</p>
                <p v-for="doc in bizDoc.docList" :key="doc.uid">
                  <a @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                  <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
                </p>
              </div>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">公司章程</span>
            </div>
            <div class="field-content">
              <div class="doc-uploader">
                <p v-if="charter.docList.length===0">--暂无--</p>
                <p v-for="doc in charter.docList" :key="doc.uid">
                  <a @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                  <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DocPreview ref="docPreview" />
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import DocPreview from "@/views/DocPreview.vue";
import {loadCompany} from "@/views/company/CompanyApi";

export default {
  components: {DocPreview, BreadcrumbItem, Breadcrumb },
  data() {
    return {
      pageTitle: "项目公司详情",
      id: "",
      partnerOptions: [],
      company: {
        companyId: "",
        companyName: "",
        partnerId: "",
        partnerName: "",
        equityReady: "",
      },
      viewUrl: baseURL + "/attachment?fileName=",
      license: {
        loading: false,
        docList: [],
        title: "营业执照"
      },
      bizDoc: {
        loading: false,
        docList: [],
        title: ""
      },
      charter: {
        loading: false,
        docList: [],
        title: "公司章程"
      },
    };
  },
  created() {
    this.id = this.$route.params.id;
    if(this.id==='0') {
      this.id = "";
    } else {
      this.startLoadCompany();
    }
  },
  mounted() {

  },
  methods: {
    preview(doc) {
      this.$refs.docPreview.previewFile(doc);
    },
    download(doc){
      window.open(doc.url, '_blank');
    },
    startLoadCompany(){
      if (this.id && this.id !== "") {
        loadCompany(this.id).then(response => {
          if (response.data.code === "SUCCESS") {
            let bizData = response.data.data;
            this.company = bizData;
            this.buildDocList(bizData.bizDocList, 'bizDoc');
            this.buildDocList(bizData.licenseDocList, 'license');
            this.buildDocList(bizData.charterDocList, 'charter');
          } else {
            this.$message.error("数据加载失败: " + response.data.errorMsg);
          }
        }).catch(error => {
          this.$message.error("数据加载失败： " + error.message);
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },

    navToListPage() {
      this.$router.push({ name: "CompanyList" });
    },

  }
}
</script>
<style scoped>
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.download-btn {
  margin-right: 30px;
}
</style>
